module.exports = __webpack_public_path__ + "static/05-dd9855657087150a87198f44847473e0.jpg";